import { render, staticRenderFns } from "./informationDetail.vue?vue&type=template&id=60f1d510&scoped=true"
import script from "./informationDetail.vue?vue&type=script&lang=js"
export * from "./informationDetail.vue?vue&type=script&lang=js"
import style0 from "./informationDetail.vue?vue&type=style&index=0&id=60f1d510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f1d510",
  null
  
)

export default component.exports